import { render } from "./DummyView.vue?vue&type=template&id=47bea2e6"
import script from "./DummyView.vue?vue&type=script&lang=js"
export * from "./DummyView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__